<template>
  <div class="login">
    <div class="login-content">
      <div class="login-logo"></div>
      <div class="login-form">
        <el-form
          ref="form"
          :model="form"
          :rules="formRules"
          v-loading="loading"
          element-loading-text="登录中"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(255, 255, 255, 0.8)"
        >
          <el-form-item prop="username">
            <el-input prefix-icon="el-icon-user-solid" v-model="form.username" placeholder="请输入用户名"></el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input
              prefix-icon="el-icon-lock"
              type="password"
              v-model="form.password"
              placeholder="请输入登录密码"
            >
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-row type="flex" justify="space-between">
              <el-checkbox v-model="isRemember">记住账号</el-checkbox>
              <span class="forgetPsw" @click="OpenDialog()" style="color: #4793e9">忘记密码</span>
              <router-link to="/regist" style="color: #4793e9">注册账号</router-link>
            </el-row>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm('form')" style="width: 100%">登录</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <el-dialog title="忘记密码" :visible.sync="dialogFormVisible"  :close-on-click-modal="false" width="25%">
      <el-form :model="form">
        <el-form-item label="登录账号" :label-width="formLabelWidth">
          <el-input v-model="fUsername" autocomplete="off" placeholder="请输入您的登录账号"></el-input>
        </el-form-item>
        <el-form-item label="手机号码" :label-width="formLabelWidth">
          <el-input v-model="fTel" autocomplete="off" placeholder="请输入门店联系方式"></el-input>
        </el-form-item>
        <el-form-item label="验证码" :label-width="formLabelWidth">
          <el-input style="width:50%;" v-model="fCode" autocomplete="off"></el-input>
          <el-button v-if="show" type="primary" style="margin-left:10px;" @click="GetCode()" >获取验证码</el-button>
          <span v-if="!show" class="count">{{count}} s后重试</span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="OpenDialog()">取 消</el-button>
        <el-button type="primary" @click="SubmitReset()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { validateUsername, validatePassword } from '../common/element-validator'
import { getCookie, setCookie, setToken, removeCookie } from '../common/auth'
import USER from '../api/user'
import RSA from '../api/RSA'
const Base64 = require('js-base64').Base64

export default {
  name: 'Login',
  data() {
    return {
      show: true,
      count: "",
      timer: null,
      dialogFormVisible: false,
      formLabelWidth: '150px',
      fUsername: '',
      fTel: '',
      fCode: '',
      form: {
        username: '',
        password: '',
      },
      formRules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          { validator: validateUsername, trigger: 'blur' },
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          // { validator: validatePassword, trigger: 'blur' },
        ],
      },
      isRemember: false,
      loading: false,
    }
  },
  methods: {
    GetCode() {
      let _self = this;
      let param = {
        userName: _self.fUsername,
        tel: _self.fTel,
      }
      USER.getCode(param).then((res) => {
        if(res.status=="success"){
          _self.$message.success("验证码获取成功!");
          const TIME_COUNT = 60;

          if (!_self.timer) {
            _self.count = TIME_COUNT;
            _self.show = false;
            _self.timer = setInterval(() => {
              if (_self.count > 0 && _self.count <= TIME_COUNT) {
                _self.count--;
              } else {
                _self.show = true;
                clearInterval(_self.timer);
                _self.timer = null;
              }
            }, 1000);
          }
        }
        else{
          _self.$message.error(res.message);
        }
      });
    },
    SubmitReset(){
      let _self = this
      let param = {
        userName: _self.fUsername,
        tel: _self.fTel,
        code:_self.fCode,
      }
      USER.submitReset(param).then((res) => {
        if(res.status=="success"){
           _self.$message.success(res.message);
          _self.dialogFormVisible=false;
        }
        else{
           _self.$message.error(res.message);
        }
      })
    },
    OpenDialog() {
      this.fUsername = '';
      this.fTel = '';
       this.fCode = '';
      this.dialogFormVisible = !this.dialogFormVisible
    },
    submitForm(formName) {
      this.$refs[formName].validate((success) => {
        if (success) {
          this.loading = true
          if (this.isRemember) {
            setCookie('username', this.form.username, '15d');
          } else {
            removeCookie('username');
          }
         var ps=RSA.encrypt(this.form.password);
          USER.login({username:this.form.username,password:ps})
            .then((res) => {
              if (res.status === 'success') {
                setToken(res.content)
                this.loading = false
                this.$router.push('/')
              } else {
                this.$store.commit('user/SET_LOGIN', false)
                this.loading = false
                this.$message.error(res.msg)
              }
            })
            .catch(() => {
              this.loading = false
            })
        } else {
          this.$store.commit('user/SET_LOGIN', false)
          this.$message.error('用户名密码格式错误')
        }
      })
    },
  },
  created() {
    //页面加载时从cookie获取登录信息
    const username = getCookie('username')
    let password = getCookie('password')
    if (password !== null) {
      password = Base64.decode(getCookie('password'))
    }
    if (username && password) {
      this.form.username = username
      this.form.password = password
      this.isRemember = true
    }
    this.$store.commit('user/SET_LOGIN', false)
    this.$store.commit('nav/INIT_NAV')
  },
  mounted() {
    window.onkeyup = (event) => {
      if (event.keyCode == 13) {
        this.submitForm('form')
      }
    }
  },
  destroyed() {
    window.onkeyup = null
  },
}
</script>

<style scoped lang="less">
.count{
    padding-left: 10px;
  }
.login {
  height: 100vh;
  background: url('../assets/image/home-bk.png');
}
.login-content {
  position: absolute;
  top: 0;
  bottom: 0;
  margin: auto 0;
  right: 14%;
  width: 440px;
  height: 530px;
  padding: 30px;
  background: #fff;
  box-shadow: 0px 10px 9px 1px rgba(0, 0, 0, 0.35);
  border-radius: 10px;
}
.login-logo {
  height: 134px;
  background: url('../assets/image/home-icon.png') no-repeat center;
  margin-bottom: 22px;
}
.forgetPsw {
  cursor: pointer;
}
</style>
